import { FiskalContract }      from '@app/modules/contract/models/contract.model';
import {
	fiskalContractActions,
	IPropsUpdateFiskalContractState
}                              from '@app/modules/contract/store/fiskal-contract-store/fiskal-contract.actions';
import { FiskalContractState } from '@app/modules/contract/store/fiskal-contract-store/fiskal-contract.state';
import { adapterReducer }      from '@core/store/adapter/adapter.reducer';
import { EntityAdapter }       from '@ngrx/entity';
import {
	createReducer,
	on
}                              from '@ngrx/store';
import { LoggerService }       from '@shared/services/logger.service';

export function fiskalContractReducer(
	storeId: string,
	initialState: FiskalContractState,
	contractAdapter: EntityAdapter<FiskalContract>,
	logger: LoggerService
) {
	return createReducer(
		initialState,

		...adapterReducer<FiskalContract, FiskalContractState>( storeId, contractAdapter, logger ),

		// FISKAL CONTRACT SPECIFIC REDUCER
		on(
			fiskalContractActions( storeId ).updateContractState,
			( state: FiskalContractState, action: IPropsUpdateFiskalContractState ) => {
				logger?.debug( action.caller + ' | fiskalContractReducer:updateContractState' );
				return {
					...state,
					entityActions: {
						create: {
							isEnabled: action?.stateUpdateData?.entityActions?.create?.isEnabled
												 ?? state.entityActions.create.isEnabled,
							showLoader: action?.stateUpdateData?.entityActions?.create?.showLoader
													?? state.entityActions.create.showLoader
						}
					}
				};
			}
		)
	);
}
